import 'react';
import { Image, Text, LinkIcon } from 'reaxl';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
var DealerFinancingCTA = _ref => {
  let {
    image = {},
    owner = {}
  } = _ref;
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx(Image, {
      src: image.src || 'https://content.autotrader.com/content/dam/autotrader/shared/img/dealer-financing-default-tile.png',
      alt: image.alt,
      className: "center-block margin-bottom-2"
    }), /*#__PURE__*/jsxs(Text, {
      children: [`Get pre-qualified with ${owner.name || ''}`, " "]
    }), /*#__PURE__*/jsx(LinkIcon, {
      children: "Visit dealer website"
    })]
  });
};
export { DealerFinancingCTA as default };
